import React, { useState } from 'react';

import { useNotification } from './NotificationContext';
import { addImg } from "../api/wsApi";

function ImageUpload({ itemId, imgPath, callback}) {
  const [file, setFile] = useState(null);
  const notification = useNotification();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      handleSubmit(file);
    }
  };

  const handleSubmit = async (file) => {
    if (!file) {
      alert('Please select a file first!');
      return;
    }

    try {
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('Failed to read image'));
        reader.readAsDataURL(file);
      });

      await addImg(itemId, base64);
      callback();

      const element = document.getElementById('prevIMG');
      if (element) {
        const save = element.src;
        element.src = "";
        setTimeout(() => {
          element.src = save;
        }, 1);
      }
      

      //console.log('Server response:', response.data);
      notification('Image uploaded', 'success');
    } catch (error) {
      console.error('Error uploading image:', error);
      notification('Error uploading image', 'error');
    }
  };

  return (
    <form className="item-photo-upload">
      <label htmlFor="file-input" className="item-photo-upload__image" title="Foto wijzigen">
          <img id="prevIMG" src={imgPath} alt="Productfoto" />
      </label>
      <input
        id="file-input"
        type="file"
        onChange={handleFileChange}
        accept="image/*"
        style={{ display: 'none' }} // Скрыть стандартный input
      />
    </form>
  );
}

export default ImageUpload;
